import { useReadQuery } from '@apollo/client';
import { useAuthenticatedAppLoader } from './loader';

/**
 * Suspends and reads all data for current user
 *
 */
export const useMe = () => {
  const data = useAuthenticatedAppLoader();

  const {
    data: { me },
  } = useReadQuery(data.meQueryRef);

  return me;
};
